import { Component, Input, OnInit, Output,EventEmitter,SimpleChanges, ViewChild, OnChanges, ViewEncapsulation } from '@angular/core';
import { Campaign3KontableComponent } from '../../campaign-3-kontable/campaign-3-kontable.component';
import { Campaign3Service } from 'app/views/campaign-3/services/campaign3.service';
import { ProductItemComplete } from 'app/views/campaign-3/models/campaign-3.model';

@Component({
  selector: 'app-campaign-3-search-product-barcode',
  templateUrl: './campaign-3-search-product-barcode.component.html',
  styleUrls: ['./campaign-3-search-product-barcode.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Campaign3SearchProductBarcodeComponent implements OnInit {
  
  @Output() productSelected: EventEmitter<ProductItemComplete> = new EventEmitter<ProductItemComplete>();

  @Input() messageInstanceIdValue: any;

//devo però recuperarmelo sto benedetto id
  kontableParametricSearch = {
    isActive: true, // booleano
    searchKey: null, // chiave
    searchValue: null // valore
  };

  
  paginationType: number = Campaign3KontableComponent.ServerPagination;
  show = {
    table: false
  }
  
  constructor(
    private srvCampaign: Campaign3Service
    ) {
  
  }
  ngOnInit() {
    if (this.messageInstanceIdValue){
      this.kontableParametricSearch = {
        isActive: true, // booleano
        searchKey: "message_instance_id", // chiave
        searchValue: this.messageInstanceIdValue // valore
      };
    }else{
      console.error("Missing parameters for query")
    }

    
    this.show.table = true;

  
  }
  onProductSelected(product: ProductItemComplete){
    if(product)
      this.productSelected.emit(product);
    else this.productSelected.emit(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/search-product-barcode/campaign-3-search-product-barcode.component.ts